module.exports = __webpack_public_path__ + "img/playback.a33c988c.svg";